module.exports = __webpack_public_path__ + "static/eth-merge-rocket-2e20c7482d5acdb4edcc1dbca0e43d54.webm";